
import { defineComponent, onMounted, reactive } from "vue";
// import { ethitransService } from "@/services/EthitransService";
import { config } from "@/Config";

export default defineComponent({
  name: "ToDoMembersList",
  components: {},
  props: {
    projectMembers: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const state = reactive({
      data: {
        imageBaseUrl: "",
        myDriveFileFolderLoad: false,
      },
      ui: {
        error: {
          hasError: false,
          errorList: {
            uploadAttachments: [] as any,
          },
        },
        isLoading: {
          getFolderList: false,
        },
        isPostLoading: {
          enableSelectedFileTag: false,
        },
      },
    });
    onMounted(() => {
      state.data.imageBaseUrl = config.imageBaseUrl;
    });

    return {
      state,
    };
  },
});
